import type { useWeightEntry } from './hooks'
import { useI18n } from '@/i18n'
import { Banner, Field, KgInput } from '@/ui'

export function WeightField({
  entry,
  label,
  hint,
}: {
  entry: ReturnType<typeof useWeightEntry>
  label: string
  hint?: string
}) {
  const { t } = useI18n()
  return (
    <div className="flex flex-col gap-2">
      <Field
        label={label}
        required
        hint={hint}
        error={!entry.twoDecimals ? t('gate.tag.twoDecimals') : undefined}
      >
        <KgInput value={entry.value} onChange={entry.setValue} />
      </Field>
      {entry.first !== null && !entry.confirmedTwice && (
        <Banner tone="warn">{t('gate.tag.typeAgain')}</Banner>
      )}
      {entry.first !== null &&
        entry.value !== null &&
        entry.outOfRange &&
        entry.value !== entry.first && <Banner tone="error">{t('gate.tag.notSame')}</Banner>}
    </div>
  )
}
